import React, { useEffect } from 'react';
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const DiscountOptions = ({ name, isTxn, isLabel, label, isSelection, placeholder, userProps, width, callback, index, type }, props) => {

    const options = [
        { key: "inflow_loyalty_discount", text: 'Loyalty Discount', value: 'inflow_loyalty_discount'},
        { key: "out_exchange_disc", text: 'Exchange Discount', value: 'out_exchange_disc' },
        { key: "inflow_corporate_discount", text: 'Corporate Discount', value: 'inflow_corporate_discount' },
        { key: "outflw_adsnl_discount", text: 'Additional Discount', value: 'outflw_adsnl_discount' },
      ]

      
    return (
        <Field 
            name={name} 
            isLabel={isLabel} 
            isTxn={isTxn} 
            label={label} 
            isSelection={isSelection} 
            component={FormikSelectComponent} 
            userProps={{ options, index, placeholder }} 
            placeholder={placeholder} 
            width={width}
            isClearable={true}
        > 
        </Field>
    )

}


export default DiscountOptions;